import { useState } from "react";

interface ResizeHandleProps {
  /** Callback when mouse down occurs */
  onMouseDown?: () => void;
}

// Helper function to create the handle indicator
export const createHandleElement = () => {
  const handle = document.createElement("div");
  handle.style.cssText = `
    position: absolute;
    left: -3px;
    top: 50%;
    transform: translateY(-50%);
    width: 10px;
    height: 40px;
    background-color: var(--color-panel-solid);
    border: 1px solid var(--gray-a6);
    border-radius: 6px;
    box-shadow: var(--shadow-2);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  `;
  
  const grip = document.createElement("div");
  grip.style.cssText = `
    width: 2px;
    height: 16px;
    background: repeating-linear-gradient(to bottom, transparent 0px, transparent 1px, var(--gray-a9) 1px, var(--gray-a9) 3px);
    border-radius: 1px;
    opacity: 0.7;
  `;
  
  handle.appendChild(grip);
  return handle;
};

export const ResizeHandle = ({ onMouseDown }: ResizeHandleProps) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <>
      {/* Invisible drag area */}
      <div
        onMouseDown={onMouseDown}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        style={{
          position: "absolute",
          left: "-4px",
          top: 0,
          bottom: 0,
          width: "12px",
          cursor: "col-resize",
          zIndex: 10,
        }}
      />

      {/* Visual edge indicator */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "4px",
          backgroundColor: isHovering ? "var(--gray-6)" : "var(--gray-4)",
          transition: "background-color 0.2s ease",
          zIndex: 15,
          pointerEvents: "none",
        }}
      />

      {/* Handle indicator */}
      <div
        style={{
          position: "absolute",
          left: "-3px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "10px",
          height: "40px",
          backgroundColor: "var(--color-panel-solid)",
          border: "1px solid var(--gray-a6)",
          borderRadius: "6px",
          boxShadow: "var(--shadow-2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 20,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            width: "2px",
            height: "16px",
            background: "repeating-linear-gradient(to bottom, transparent 0px, transparent 1px, var(--gray-a9) 1px, var(--gray-a9) 3px)",
            borderRadius: "1px",
            opacity: 0.7,
          }}
        />
      </div>
    </>
  );
};